import React, { useState } from "react";

import { Field, useForm } from "react-final-form";

import DatePicker from "react-datepicker";
import moment from "moment";
import { MdDateRange } from "react-icons/md";
import Cards from "react-credit-cards";
import AmsPageModal from "../Modals/AmsPageModal";
import {
  Condition,
  Error,
  required,
  composeValidators,
  hasPattern,
  validCreditCard,
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
  validateExpiry,
  ValidateCVC,
} from "./Shared";
import { useSelector } from "react-redux";

import "react-credit-cards/es/styles-compiled.css";

const Payment = (props) => {
  const formApi = useForm();
  const { values } = formApi.getState();

  const { isAuthed } = props;

  const { directDebit: DirectDebit, creditCard: CreditCard } = useSelector(
    (state) => state.settings
  );

  const [bpointModalOpen, setBpointModalOpen] = useState(false);
  const [hasFocus, setHasFocus] = useState("");
  const [card_cvv, set_card_cvv] = useState(values.cc_cvv || "");
  const [card_expiry, set_card_expiry] = useState(values.cc_expiry || "");
  const [card_name, set_card_name] = useState(values.cc_name || "");
  const [card_number, set_card_number] = useState(values.cc_number || "");

  return (
    <div id="detailsForm" className="form donation_panel__content">
      {bpointModalOpen && (
        <AmsPageModal
          isOpen
          page="direct-debit-bpoint-agreement"
          setModalClosed={() => {
            setBpointModalOpen(false);
          }}
        />
      )}

      <div className="form__block">
        <div className="donation_panel__header">
          <span className="tabbed_nav__number">3</span>
          <span className="tabbed_nav__title">How To Pay</span>
        </div>
        <h3 className="donation_panel__heading">
          You're on your way to supporting <span>{values.mission_name}</span>
          <br /> with a{" "}
          <span className="donation_panel__frequency">
            {values.frequency}
          </span>{" "}
          donation of <span>${values.amount}</span>
        </h3>
      </div>
      <div className="form__block">
        <div className="row donation_panel__row donation_panel__group align-center">
          <h3 className="col-2 donation_panel__title">Pay by:</h3>
          <div className="col-8 form__radioGroup">
            <div className="form__radio col-4">
              <Field
                type="radio"
                component="input"
                name="payment_type"
                value="Direct Debit"
                id="payment-form-direct-debit"
              />
              <label
                htmlFor="payment-form-direct-debit"
                className="radio_label"
              >
                Direct Debit
              </label>
            </div>
            <div className="form__radio col-4">
              <Field
                type="radio"
                component="input"
                name="payment_type"
                value="Credit Card"
                id="payment-form-credit-card"
              />
              <label htmlFor="payment-form-credit-card" className="radio_label">
                Credit Card
              </label>
            </div>
            <div className="form__radio col-4">
              <Field
                type="radio"
                component="input"
                name="payment_type"
                value="Direct Deposit"
                id="payment-form-direct-deposit"
              />
              <label
                htmlFor="payment-form-direct-deposit"
                className="radio_label"
              >
                Direct Deposit
              </label>
            </div>
          </div>
        </div>

        <Condition when="payment_type" is="Direct Debit">
          <h3 className="donation_panel__title">Pay by Direct Debit</h3>
          <div className="row donation_panel__row donation_panel__field">
            <div className="col-3">
              <label>Preferred Date of Payment(s)</label>
              <Field validate={required} name="prefered_debit_date">
                {({ input }) => {
                  const { value, ...rest } = input;
                  return (
                    <div className="donation_panel__datepicker input__icon--right relative inline-block">
                      <DatePicker
                        id="prefered_debit_date"
                        className="flex-row__stretch"
                        {...rest}
                        locale="en-AU"
                        dateFormat="Y-MM-dd"
                        minDate={moment().add(1, "day").toDate()}
                        maxDate={moment().add(6, "months").toDate()}
                        selected={input.value.toDate()}
                        onChange={(date) =>
                          input.onChange(
                            moment(date).isValid() ? moment(date) : undefined
                          )
                        }
                        onChangeRaw={(e) => e.preventDefault()} // force user to use datepicker (rather than type arbitary dates)
                      />
                      <MdDateRange className="position__center--right blue is-not-interactive" />
                    </div>
                  );
                }}
              </Field>

              <Error name="prefered_debit_date" />
            </div>
          </div>

          {isAuthed && (
            <div className="row donation_panel__row donation_panel__field">
              <div className="col-5">
                <label>Pay Using</label>
                <Field
                  component="select"
                  name="prefered_dd_payment"
                  id="prefered_dd_payment"
                  label="Title"
                >
                  {DirectDebit?.id && (
                    <option value={DirectDebit.id}>
                      Existing Account: {DirectDebit.number_masked}
                    </option>
                  )}
                  <option value="new">New Account</option>
                </Field>
              </div>
            </div>
          )}

          <Condition when="prefered_dd_payment" is="new">
            <div>
              <div className="row donation_panel__row donation_panel__field">
                <div className="col-6">
                  <label>Account Holder</label>
                  <Field
                    validate={required}
                    component="input"
                    placeholder=""
                    id="account_holder"
                    name="account_holder"
                    autoComplete="name"
                    className="flex-row__stretch "
                  />
                  <Error name="account_holder" />
                </div>
              </div>

              <div className="row donation_panel__row donation_panel__field">
                <div className="col-3 donation_panel__field">
                  <label>BSB Number</label>
                  <Field
                    component="input"
                    placeholder="000 000"
                    id="bsb_number"
                    name="bsb_number"
                    autoComplete="bsb_number"
                    className="flex-row__stretch "
                    validate={composeValidators(
                      required,
                      hasPattern(
                        /\d{3} \d{3}/,
                        "Please enter a valid BSB Number"
                      )
                    )}
                    parse={(value) => {
                      if (!value) return value;
                      const onlyNums = value.replace(/[^\d]/g, "");
                      if (onlyNums.length <= 3) return onlyNums;
                      return `${onlyNums.slice(0, 3)} ${onlyNums.slice(3, 6)}`;
                    }}
                  />
                  <Error name="bsb_number" />
                </div>

                <div className="col-3 donation_panel__field">
                  <label>Account Number</label>
                  <Field
                    component="input"
                    placeholder="000 000000"
                    id="account_number"
                    name="account_number"
                    autoComplete="account_number"
                    className="flex-row__stretch "
                    validate={composeValidators(
                      required,
                      hasPattern(
                        /\d{3} \d{3,7}/,
                        "Please enter a valid Account Number"
                      )
                    )}
                    parse={(value) => {
                      if (!value) return value;
                      const onlyNums = value.replace(/[^\d]/g, "");
                      if (onlyNums.length <= 3) return onlyNums;
                      return `${onlyNums.slice(0, 3)} ${onlyNums.slice(3)}`;
                    }}
                  />
                  <Error name="account_number" />
                </div>
              </div>
            </div>
          </Condition>

          <div className="row donation_panel__row">
            <label>
              <Field
                component="input"
                type="checkbox"
                name="AcceptBADirectDebitTC"
                id="checkbox-authorize"
                validate={required}
              />
              &nbsp;I agree to the&nbsp;
              <a onClick={(e) => setBpointModalOpen(true)}>
                {" "}
                Direct Debit Agreement
              </a>
            </label>
          </div>
          <Error name="AcceptBADirectDebitTC" />
        </Condition>

        <Condition when="payment_type" is="Credit Card">
          <h3 className="donation_panel__title">Pay by Credit Card</h3>
          <div className="row donation_panel__row donation_panel__field">
            <div className="col-3">
              <label>Preferred Date of Payment(s)</label>
              <Field validate={required} name="prefered_cc_date">
                {({ input }) => {
                  const { value, ...rest } = input;
                  return (
                    <div className="donation_panel__datepicker input__icon--right relative inline-block">
                      <DatePicker
                        id="prefered_cc_date"
                        className="flex-row__stretch "
                        {...rest}
                        locale="en-AU"
                        dateFormat="Y-MM-dd"
                        minDate={moment().add(1, "day").toDate()}
                        maxDate={moment().add(6, "months").toDate()}
                        selected={input.value.toDate()}
                        onChange={(date) =>
                          input.onChange(
                            moment(date).isValid() ? moment(date) : undefined
                          )
                        }
                        onChangeRaw={(e) => e.preventDefault()} // force user to use datepicker (rather than type arbitary dates)
                      />
                      <MdDateRange className="position__center--right blue is-not-interactive" />
                    </div>
                  );
                }}
              </Field>
              <Error name="prefered_cc_date" />
            </div>
          </div>

          {isAuthed && (
            <div className="row donation_panel__row donation_panel__field">
              <div className="col-5">
                <label>Pay Using</label>
                <Field
                  component="select"
                  name="prefered_cc_payment"
                  id="prefered_cc_payment"
                  label="Title"
                >
                  {CreditCard?.id && (
                    <option value={CreditCard.id}>
                      Existing Account: {CreditCard.number_masked}
                    </option>
                  )}

                  <option value="new">New Credit Card</option>
                </Field>
              </div>
            </div>
          )}

          <Condition when="prefered_cc_payment" is="new">
            <div className="row">
              <div className="col-7">
                <div className="donation_panel__field">
                  <div className="col-10 donation_panel__field">
                    <label>
                      Name on Card <span> - Visa and Mastercard accepted</span>
                    </label>
                    <Field name="cc_name" validate={required}>
                      {({ input }) => (
                        <input
                          type="text"
                          placeholder="Name on Card"
                          id="cc_name"
                          autoComplete="cc-name"
                          className="flex-row__stretch "
                          {...input}
                          onFocus={(e) => {
                            setHasFocus("name");
                            input.onFocus(e);
                          }}
                          onBlur={(e) => {
                            setHasFocus("");
                            input.onBlur(e);
                          }}
                          onChange={(e) => {
                            set_card_name(e.target.value);
                            input.onChange(e);
                          }}
                        />
                      )}
                    </Field>
                    <Error name="cc_name" />
                  </div>
                  <div className="col-10 donation_panel__field">
                    <label>Card Number</label>
                    <Field
                      name="cc_number"
                      parse={formatCreditCardNumber}
                      validate={composeValidators(required, validCreditCard)}
                    >
                      {({ input }) => (
                        <input
                          type="text"
                          placeholder="0000 0000 0000 0000"
                          id="cc_number"
                          autoComplete="cc-number"
                          className="flex-row__stretch "
                          {...input}
                          onFocus={(e) => {
                            setHasFocus("number");
                            input.onFocus(e);
                          }}
                          onBlur={(e) => {
                            setHasFocus("");
                            input.onBlur(e);
                          }}
                          onChange={(e) => {
                            set_card_number(
                              formatCreditCardNumber(e.target.value)
                            );
                            input.onChange(e);
                          }}
                        />
                      )}
                    </Field>
                    <Error name="cc_number" />
                  </div>
                </div>
                <div>
                  <div className="col-10 donation_panel__row donation_panel__field">
                    <div className="col-4 donation_panel__field">
                      <label>Card Expiry</label>

                      <Field
                        name="cc_expiry"
                        parse={formatExpirationDate}
                        validate={composeValidators(required, validateExpiry)}
                      >
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="MM/YY"
                            id="cc_expiry"
                            autoComplete="cc-exp"
                            className="flex-row__stretch "
                            {...input}
                            onFocus={(e) => {
                              setHasFocus("expiry");
                              input.onFocus(e);
                            }}
                            onBlur={(e) => {
                              setHasFocus("");
                              input.onBlur(e);
                            }}
                            onChange={(e) => {
                              set_card_expiry(
                                formatExpirationDate(e.target.value)
                              );
                              input.onChange(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="cc_expiry" />
                    </div>

                    <div className="col-4 donation_panel__field">
                      <label>CVV</label>
                      <Field
                        name="cc_cvv"
                        parse={(value) => formatCVC(value, values)}
                        validate={composeValidators(required, ValidateCVC)}
                      >
                        {({ input }) => (
                          <input
                            type="text"
                            placeholder="000"
                            id="cc_cvv"
                            autoComplete="cc-csc"
                            className="flex-row__stretch "
                            {...input}
                            onFocus={(e) => {
                              setHasFocus("cvc");
                              input.onFocus(e);
                            }}
                            onBlur={(e) => {
                              setHasFocus("");
                              input.onBlur(e);
                            }}
                            onChange={(e) => {
                              set_card_cvv(formatCVC(e.target.value, values));
                              input.onChange(e);
                            }}
                          />
                        )}
                      </Field>
                      <Error name="cc_cvv" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <Cards
                  cvc={card_cvv || ""}
                  expiry={card_expiry || ""}
                  focused={hasFocus}
                  name={card_name || ""}
                  number={card_number || ""}
                />
              </div>
            </div>
          </Condition>
        </Condition>

        <Condition when="payment_type" is="Direct Deposit">
          <h3 className="donation_panel__title">Pay by Direct Deposit</h3>
          <div className="row donation_panel__row">
            <p>
              Our account details and your unique reference code will be emailed
              to you and will also appear on the following screen when you click
              'Process My Support', then 'Confirm My Support'.
            </p>
          </div>
        </Condition>
      </div>
    </div>
  );
};

export default Payment;
